import * as Xlsx from "xlsx";
import { dateFormat, isString } from "@szgc/plt-core-v2";

function getRealLenth(target: string | number) {
  let str = target + "";
  if (str == null) return 0;
  if (!isString(str)) {
    str += "";
  }
  return str.replace(/[^\x00-\xff]/g, "01").length;
}

/**
 * 视图导出模型
 */
interface ExportOptions {
  /**
   * 文件名
   */
  fileName: string;
  /**
   * 标题数组
   */
  header: Array<string>;
  /**
   * 数据数组，二维数组，顺序规则应与header保持一致
   */
  data: Array<Array<string>>;
}

export function exportExcel(options: ExportOptions) {
  const worksheet = Xlsx.utils.json_to_sheet(options.data);
  const workbook = Xlsx.utils.book_new();
  Xlsx.utils.book_append_sheet(workbook, worksheet, options.fileName);
  // console.log(options.header);
  Xlsx.utils.sheet_add_aoa(worksheet, [options.header], {
    origin: "A1"
  });

  const wchList: Array<{ wch: number }> = [];
  options.header.forEach((d) => {
    wchList.push({
      wch: d.length + 3
    });
  });
  options.data.forEach((row) => {
    row.forEach((d, i) => {
      const len = getRealLenth(d);
      if (len > wchList[i].wch) {
        wchList[i].wch = len + 3;
      }
    });
  });

  worksheet["!cols"] = wchList;

  const now = dateFormat(new Date(), "_YYYY_MM_DD");
  Xlsx.writeFile(workbook, options.fileName + now + ".xlsx");
}

